import { createSelector } from 'reselect';

export const readyLoadsSelector = createSelector(
  (state) => state.loads,
  (loads) => (
    _.filter(loads, {state: 'ready_for_pickup'})
  )
);
